
import { mapState, mapGetters, mapActions } from "vuex";
import CurrencyConverter from "../common/currency-converter.vue";
import reportBusinessGraph from "./report-business-graph.vue";
export default {
  components: { reportBusinessGraph, CurrencyConverter },
  data() {
    return {
      items: [
        {
          value: "orders",
          label: "Orders",
          unit: "No"
        },
        {
          value: "revenue",
          label: "Revenue",
          unit: "currency"
        },
        {
          value: "item-sold",
          label: "Item Sold",
          unit: "No"
        },
        {
          value: "discount-given",
          label: "Discount Given",
          unit: "currency"
        },
        {
          value: "lost-revenue",
          label: "Lost Revenue",
          unit: "currency"
        }
      ],
      selectedItem: "",
      periods: [
        { value: "hour", label: "Hourly" },
        { value: "day", label: "Daily" }
      ],
      selectedPeriod: ""
    };
  },
  created() {
    this.selectedItem = this.items[0].value;
    this.selectedPeriod = this.periods[0].value;
  },
  mounted() {
    this.fetchBusinessGraphData();
  },
  computed: {
    ...mapState("report", [
      "products",
      "summary",
      "aggregates",
      "businessGraphDataLoading",
      "selectedTimeRange"
    ]),
    ...mapGetters("report", [
      "getChannels",
      "getTotalRevenue",
      "getTotalDiscountGiven",
      "getTotalLostRevenue"
    ]),
    getOrderCount() {
      return (
        Number(this.aggregates?.completed || 0) +
        Number(this.aggregates?.cancelled || 0)
      );
      // return (
      //   (this.summary && this.summary.reduce((tot, el) => tot + el.count, 0)) ||
      //   0
      // );
    },

    getItemSold() {
      const $this = this;
      return (
        (this.products &&
          this.products.reduce(
            function (tot, el) {
              return (
                tot +
                this.getChannels.reduce(
                  (itemTot, channel) => itemTot + el[channel],
                  0
                )
              );
            }.bind(this),
            0
          )) ||
        0
      );
    }
  },
  methods: {
    ...mapActions("report", ["getBusinessGraphData"]),
    fetchBusinessGraphData() {
      this.getBusinessGraphData({
        data: { period: this.selectedPeriod, type: this.selectedItem }
      });
    },
    getItemPrefix(item) {
      switch (item) {
        case "orders":
          return this.getOrderCount;
        case "revenue":
          return this.getTotalRevenue;
        case "item-sold":
          return this.getItemSold;
        case "discount-given":
          return this.getTotalDiscountGiven;
        case "lost-revenue":
          return this.getTotalLostRevenue;
      }
    }
  }
};
